<template>
  <div class="submit-popup">
    <div class="submit-popup__text">Submit the changes?</div>
    <div class="submit-popup__actions">
      <button
        class="button button-secondary"
        @click="$emit('submitPopup', false)"
      >
        Cancel
      </button>
      <button class="button button-primary" @click="$emit('submitPopup', true)">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupLogSubmit'
}
</script>

<style lang="scss" scoped>
.submit-popup {
  &__text {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
  }
  &__actions {
    display: flex;

    button + button {
      margin-left: 20px;
    }
  }
}
</style>
